module.exports = __webpack_public_path__ + "img/reports.a278c9e5.svg";